import { Button, Grid, Stack, Tooltip, Typography } from '@mui/material';
import SuicidalIdeation from './SuicidalIdeation/SuicidalIdeation';
import HomicidalIdeation from './HomicidalIdeation/HomicidalIdeation';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../store/store';
import { getSuicidalHomicidalIdeationsById, gotoNextMenu, gotoPreviousMenu, saveSuicidalHomicidalIdeations } from '../../../store/assessment.slice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import AlertDialog from '../../AlertDialog/AlertDialog';
import BHDiagnosticConfirmationBody from '../../Shared/BHDiagnosticConfirmationBody';
import { DiagnosticType } from '../../../Enum/DiagnosticType';
import { StatusEnum } from '../../../Enum/StatusEnum';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SafetyPlanPromptModal from '../../SafetyPlanPromptModal/SafetyPlanPromptModal';
import { openSafetyPlanModal, setShowSafetyPlanModal } from '../../../store/behaviorOrSafetyPlanSlice.slice';
import InfoIcon from '@mui/icons-material/Info';
import HelpPage from '../../../assets/documents/Assessment_PHQ9_SIHI_DAST.pdf';

const SuicidalHomicidalIdeation: React.FC<{ memberId: string }> = ({ memberId }) => {
    const dispatch = useAppDispatch();
    const { engagementDraft } = useSelector((state: RootState) => state.documentEngagement);
    const { suicidalHomicidalIdeations } = useSelector((state: RootState) => state.assessment);
    const [showSaveAlert, setShowSaveAlert] = useState<boolean>(false);
    const { showSafetyPlanModal } = useSelector((state: RootState) => state.safetyPlanSlice);
    const [isChanged, setIsChanged] = useState<boolean>(false);

    const handleOnConfirmToNext = (isWithoutComplete = false) => {
        if (isWithoutComplete) {
            dispatch(saveSuicidalHomicidalIdeations({ ...suicidalHomicidalIdeations, Status: StatusEnum.Completed, MemberId: memberId }, true));
        } else {
            dispatch(gotoNextMenu());
        }
    };

    const isSafetyPlanTriggered = (): boolean => {
        const positiveSIOptions = ['Current', 'Recent', 'Past'];
        const positiveHIOptions = ['With Plan', 'Specific victim'];
        const suicidalIdeationName: string = suicidalHomicidalIdeations?.Suicide?.SuicidalIdeation?.Type?.Name ?? '';
        const homicidalName: string = suicidalHomicidalIdeations?.Homicide?.Homicidal?.Type?.Name ?? '';
        return positiveSIOptions.includes(suicidalIdeationName) || positiveHIOptions.includes(homicidalName);
    };

    const handleOnClickSave = () => {
        if (isSafetyPlanTriggered()) {
            dispatch(openSafetyPlanModal());
            return;
        }
        setShowSaveAlert(true);
    };

    const handleSafetyPlanModalComplete = () => {
        dispatch(setShowSafetyPlanModal(false));
        setShowSaveAlert(true);
    };

    useEffect(() => {
        dispatch(getSuicidalHomicidalIdeationsById(engagementDraft.SuicidalHomicidalIdeationId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Grid container direction="column" spacing={2} className="content-panel">
            <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ ml: 2 }}>
                <Typography variant="h6">Suicidal/Homicidal Ideation</Typography>
                <Tooltip title="Suicidal/Homicidal Ideation Help Document">
                    <InfoIcon color="primary" fontSize="small" cursor="pointer" onClick={() => window.open(`${HelpPage}`, '_blank')} />
                </Tooltip>
            </Stack>
            <Grid className="content-form" sx={{ mt: 3 }}>
                <Stack spacing={2}>
                    <SuicidalIdeation memberId={memberId} setIsChanged={setIsChanged} />
                    <HomicidalIdeation memberId={memberId} setIsChanged={setIsChanged} />
                </Stack>
            </Grid>
            <Grid justifyContent="flex-end" className="content-footer">
                <Button variant="contained" color="secondary" sx={{ mr: 3 }} onClick={() => dispatch(gotoPreviousMenu())} startIcon={<ArrowBackIosIcon />}>
                    Previous
                </Button>
                <Button type="submit" variant="contained" onClick={handleOnClickSave} endIcon={<ArrowForwardIosIcon />}>
                    Next
                </Button>
            </Grid>
            {Boolean(engagementDraft.SuicidalHomicidalIdeationId || isChanged) ? (
                <AlertDialog
                    open={showSaveAlert}
                    title="Suicidal/Homicidal Ideation Assessment"
                    cancelText="Go Back"
                    okText="Confirm"
                    onConfirm={() => handleOnConfirmToNext(true)}
                    onSkip={() => handleOnConfirmToNext()}
                    onClose={() => setShowSaveAlert(false)}
                    showBottomCenter={true}
                    message="I confirm and acknowledge that Suicidal/Homicidal Ideation assessment is completed."
                />
            ) : (
                <AlertDialog
                    open={showSaveAlert}
                    title="Suicidal/Homicidal Ideation Assessment"
                    cancelText="No"
                    okText="Yes, Proceed"
                    onConfirm={() => handleOnConfirmToNext(true)}
                    showBottomCenter={true}
                    onClose={() => setShowSaveAlert(false)}
                    renderBody={() =>
                        BHDiagnosticConfirmationBody({
                            assessmentName: 'Suicidal/Homicidal Ideation',
                            diagnosticType: engagementDraft.DiagnosticStatus?.DiagnosticType ?? DiagnosticType.None,
                        })
                    }
                />
            )}
            <SafetyPlanPromptModal
                open={showSafetyPlanModal}
                onCancel={() => dispatch(setShowSafetyPlanModal(false))}
                onComplete={handleSafetyPlanModalComplete}
            />
        </Grid>
    );
};

export default SuicidalHomicidalIdeation;
